module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"title":"よくあるご質問","description":"倉庫のへの一括問い合わせから入出荷管理までできる倉庫利用サービス「WareX」へのよくある質問をまとめてご紹介しています。","more":"さらに詳しく知りたい方は、{newline-sp}以下のページからお問い合わせください。","btn":{"contact":"お問い合わせはこちら"}},"en":{"title":"FAQ"}}')
  delete Component.options._Ctor
}
